import React from 'react';
import i18n from '@i18n';
import { firstToUpperCase, formatMoney } from '@/common/client';
import { DialogActions, DialogBody, DialogButton, DialogTitle } from '@/ui/dialogs/Dialog';

function CashinPaidOut({ cashinTransaction, closeDialog }) {
    const reason = i18n('ticketus.cashin.paidout', formatMoney(cashinTransaction.get('amount'), 'EUR'));
    return (
        <div className="cashin-paidout">
            <DialogTitle>
                <h2 className="icon">{firstToUpperCase(i18n('commons.term.odkupH1'))}</h2>
            </DialogTitle>
            <DialogBody>{reason}</DialogBody>
            <DialogActions>
                <DialogButton onClick={() => closeDialog(reason)}>{i18n('cashin.term.close')}</DialogButton>
            </DialogActions>
        </div>
    );
}

export default CashinPaidOut;
